import GridTanStack from './GridTanStack';

function Grid(props) {
  return <GridTanStack {...props} />;
}

export default Grid;
